// extracted by mini-css-extract-plugin
export default {"header":"HeaderSimple_header__0pcAe","inner":"HeaderSimple_inner__X185L","link":"HeaderSimple_link__n6HwK"};